exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{font-family:Arial,sans-serif}h1{color:#333;text-align:center}table{width:100%;border-collapse:collapse;margin-top:20px}td,th{padding:10px;text-align:left;border-bottom:1px solid #ddd}th{background-color:#f2f2f2}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-35703cdf","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/school/exams/exams.vue
// module id = 105
// module chunks = 0